document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-ak-front-carousel]').forEach((carousel) => {
    const scroller = carousel.querySelector('[data-ak-front-window]');
    const track = carousel.querySelector('[data-ak-front-track]');
    const prev = carousel.querySelector('[data-ak-front-prev]');
    const next = carousel.querySelector('[data-ak-front-next]');
    const items = Array.from(carousel.querySelectorAll('.ak-front-product'));
    if (!scroller || !track || items.length < 2) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let timer = null;
    let normalizeTimer = null;
    let paused = false;

    const gap = () => parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
    const step = () => (items[0]?.getBoundingClientRect().width || 180) + gap();
    const halfWidth = () => track.scrollWidth / 2;

    const normalize = () => {
      const half = halfWidth();
      if (!half) return;
      if (scroller.scrollLeft >= half) scroller.scrollLeft -= half;
    };

    const move = (direction) => {
      const half = halfWidth();
      const amount = step();
      if (direction < 0 && scroller.scrollLeft < amount * 1.15 && half) {
        scroller.scrollLeft += half;
      }
      scroller.scrollBy({ left: direction * amount, behavior: reducedMotion ? 'auto' : 'smooth' });
      clearTimeout(normalizeTimer);
      normalizeTimer = setTimeout(normalize, reducedMotion ? 20 : 650);
    };

    prev?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));

    const stopAuto = () => {
      paused = true;
      if (timer) clearInterval(timer);
      timer = null;
    };

    const startAuto = () => {
      paused = false;
      if (reducedMotion || timer || items.length < 4) return;
      timer = setInterval(() => {
        if (!paused && document.visibilityState === 'visible') move(1);
      }, 2600);
    };

    carousel.addEventListener('pointerenter', stopAuto);
    carousel.addEventListener('pointerleave', startAuto);
    carousel.addEventListener('focusin', stopAuto);
    carousel.addEventListener('focusout', startAuto);
    scroller.addEventListener('touchstart', stopAuto, { passive: true });
    scroller.addEventListener('touchend', () => {
      setTimeout(normalize, 180);
      setTimeout(startAuto, 900);
    }, { passive: true });

    scroller.addEventListener('scroll', () => {
      const half = halfWidth();
      if (half && scroller.scrollLeft > half + step() * 2) {
        scroller.scrollLeft -= half;
      }
    }, { passive: true });

    scroller.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        move(1);
      }
    });

    startAuto();
  });
});
